import "./index.scss";

import { Box } from "@mui/material";
import { WorkoutPlan } from "models/workoutplan";

import CardioProgramSection from "./CardioProgramSection";
import FlexibilityProgramSection from "./FlexibilityProgramSection";
import PrimaryDetailsSection from "./PrimaryDetailsSection";
import StrengthProgramSection from "./StrengthProgramSection";

const WorkoutPlanSection = (props: {
  workoutPlan: WorkoutPlan;
  goalOptions: any[];
  upperBodyStretchOptions: any[];
  lowerBodyStretchOptions: any[];
  perceivedExertionOptions: any[];
}) => {
  const {
    workoutPlan,
    goalOptions,
    upperBodyStretchOptions,
    lowerBodyStretchOptions,
    perceivedExertionOptions,
  } = props;

  return (
    <Box className="workoutplan-container">
      <PrimaryDetailsSection workoutPlan={workoutPlan} goalOptions={goalOptions} />
      {workoutPlan?.isFlexibilityProgramIncluded && (
        <FlexibilityProgramSection
          workoutPlan={workoutPlan}
          upperBodyStretchesOptions={upperBodyStretchOptions}
          lowerBodyStretchesOptions={lowerBodyStretchOptions}
        />
      )}
      {workoutPlan?.isCardioProgramIncluded && (
        <CardioProgramSection
          workoutPlan={workoutPlan}
          perceivedExertionOptions={perceivedExertionOptions}
        />
      )}
      {workoutPlan?.isStrengthProgramIncluded && (
        <StrengthProgramSection workoutPlan={workoutPlan} />
      )}
    </Box>
  );
};

export default WorkoutPlanSection;
